
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/bakkt",
      function () {
        return require("private-next-pages/docs/auth/partnerships/bakkt.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/bakkt"])
      });
    }
  